import { BaseFetch } from "../main-model"
export default class ReportGpaModel extends BaseFetch {
    getReportGpaBy = (data) =>
    this.authFetch({
      url: "report-gpa/getReportGpaBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportGpaChartBy = (data) =>
    this.authFetch({
      url: "report-gpa/getReportGpaChartBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
